import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Box } from '../../../components/atoms/Box';
import { Typography } from '../../../components/atoms/Typography';

import { COLORS } from '../../../configs/colors';

export const RoleTypography = styled(Typography)`
  padding-bottom: 10px;
`;

export const RoleBox = styled(Box)`
  width: 100%;
  padding: 10px;
  border: 2px solid ${COLORS.CardBorder};
  border-radius: 5px;
  background-color: ${COLORS.CardBackground};
  box-sizing: border-box;
`;

export const PageActionTypography = styled(Typography)`
  font-size: 18px;
  font-weight: 500;
  padding: 5px;
  margin-inline: 22.5px;
  display: flex;
  justify-content: space-between;
`;

export const ActionGrid = styled(Grid)`
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 5px;
  width: 100%;
  padding-bottom: 10px;
`;
